// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oheRO","input":"styles_input__3qioi"};